import { MovementData } from "graphql/types"

export const getCurrentLocation = (
  movementData: MovementData[]
): string | null => {
  if (!movementData.length) {
    return null
  }
  const latestMovement = [...movementData].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  )[0]

  return latestMovement.location
}
